// levelNames.ts — the three named agent tiers, for the admin UI (hierarchy
// restructure H7). Mirrors the backend source of truth
// shared/src/core/lib/levelNames.js. The DB keeps an integer agents.level
// (1..3); every admin-facing surface renders these names instead of "L{n}".

export const LEVEL_NAMES: Record<number, string> = {
  1: 'Super Master',
  2: 'Master',
  3: 'Agent',
};

/** Display name for a level. Unknown/legacy/placeholder values fall back to
 *  "L{value}" (e.g. a "—" placeholder renders "L—", matching the old UI). */
export function levelName(level: number | string | null | undefined): string {
  const n = Number(level);
  return LEVEL_NAMES[n] || `L${level ?? '?'}`;
}
